import get from 'lodash/get';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  deleteGiftCard,
  fetchGiftCardSummary,
} from '../actions';
import withNotifications from '../../../common/withNotifications';
import { getShop } from '../../../auth/selectors';
import GiftCardModal from '../components/GiftCardModal';

const GiftCardModalContainer = compose(
  withNotifications,
  connect(
    state => ({
      shopId: getShop(state),
    }),
    { fetchGiftCardSummary, deleteGiftCard },
  ),
  withHandlers({
    closeModal: props => () => props.setGiftCard(),
    deleteGiftCard: props => () =>
      props.deleteGiftCard(props.shopId, get(props, 'giftCard.id')).then(() => {
        props.fetchGiftCardSummary(props.shopId);
        props.setGiftCard();
        props.addNotification({
          title: 'Success',
          level: 'success',
          message: 'Gift card deleted',
        });
      }),
  }),
)(GiftCardModal);

export default GiftCardModalContainer;
